/** Catmull-Rom spline — 15 sub-points per segment, returns SVG path d */
export function smoothPath(pts: [number, number][], tension = 0.3): string {
  if (pts.length < 2) return ''
  if (pts.length === 2) return 'M' + pts[0][0] + ',' + pts[0][1] + 'L' + pts[1][0] + ',' + pts[1][1]
  const STEPS = 15
  const result: string[] = ['M' + pts[0][0].toFixed(1) + ',' + pts[0][1].toFixed(1)]
  for (let i = 0; i < pts.length - 1; i++) {
    const p0 = pts[Math.max(0, i - 1)]
    const p1 = pts[i]
    const p2 = pts[Math.min(pts.length - 1, i + 1)]
    const p3 = pts[Math.min(pts.length - 1, i + 2)]
    for (let t = 1; t <= STEPS; t++) {
      const s = t / STEPS
      const s2 = s * s
      const s3 = s2 * s
      const x = 0.5 * ((2 * p1[0]) + (-p0[0] + p2[0]) * s * tension * 3 +
        (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * s2 * tension * 3 +
        (-p0[0] + 3 * p1[0] - 3 * p2[0] + p3[0]) * s3 * tension * 3)
      const y = 0.5 * ((2 * p1[1]) + (-p0[1] + p2[1]) * s * tension * 3 +
        (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * s2 * tension * 3 +
        (-p0[1] + 3 * p1[1] - 3 * p2[1] + p3[1]) * s3 * tension * 3)
      result.push('L' + x.toFixed(1) + ',' + y.toFixed(1))
    }
  }
  return result.join('')
}
